import API from './API.js'
import axios from 'axios'

export default class SessionAttendance extends API {
  constructor() {
    super('online_Session_attendance')
  }

  //getUserAttendLecture
  async getUserAttendLecture(params) {
    const response = await axios.get(`/${this.route}/user-attend-lecture`, { params })
    return response.data
  }
  async attendLecture(params) {
    try {
      const response =  await axios.post(`online_session/attend_lecture`, { params });
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async getStudentAttend(params) {
    const response = await axios.get(`online-session-attendance/get-student-attend`, { params })
    return response.data
  }
}
